import useTheme from '../../hooks/ui/useTheme';

interface Props {
  className?: string;
  style?: object;
  color?: string;
}

export default function UserIcon(props: Props) {
  const { className, color, style } = props;

  const theme = useTheme();

  return (
    <svg className={className ?? 'h-4 w-4'} viewBox="0 0 20 19" fill="none" style={style}>
      <path
        d="M9.99414 18.1846C14.9775 18.1846 19.0908 14.0713 19.0908 9.08789C19.0908 4.11328 14.9688 0 9.98535 0C5.01074 0 0.90625 4.11328 0.90625 9.08789C0.90625 14.0713 5.01953 18.1846 9.99414 18.1846ZM9.99414 8.78027C8.71094 8.78027 7.67383 7.69922 7.67383 6.24902C7.67383 4.9043 8.71094 3.7793 9.99414 3.7793C11.2686 3.7793 12.3057 4.9043 12.3057 6.24902C12.3057 7.69922 11.2686 8.78906 9.99414 8.78027ZM5.96875 13.667C5.55566 13.667 5.3623 13.3945 5.3623 13.0254C5.3623 12.041 6.82129 9.50098 9.99414 9.50098C13.1582 9.50098 14.6172 12.041 14.6172 13.0254C14.6172 13.3945 14.4238 13.667 14.0195 13.667H5.96875Z"
        fill={color ?? theme.color.gray.DEFAULT}
      />
    </svg>
  );
}
